export const MAX_STAT = 255;

export enum E_POKEMON_TYPE {
'normal' = 1,
'fighting' = 2,
'flying' = 3,
'poison' = 4,
'ground' = 5,
'rock' = 6,
'bug' = 7,
'ghost' = 8,
'steel' = 9,
'fire' = 10,
'water' = 11,
'grass' = 12,
'electric' = 13,
'psychic' = 14,
'ice' = 15,
'dragon' = 16,
'dark' = 17,
'fairy' = 18,
'unknown' = 1001,
'shadow' = 1002,
}

export enum E_STAT_NAME {
  'hp' = 'HP',
  'attack' = 'Attack',
  'defense' = 'Defense',
  'special-attack' = 'Sp. Attack',
  'special-defense' = 'Sp. Defense',
  'speed' = 'Speed',
}

export const VALID_POKEMON_COUNT = 898;